// Circular SEO score gauge (0-100) with colour grading.
export default function SeoScore({ score = 0, size = 92, stroke = 8 }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score));
  const dash = (pct / 100) * c;
  const color = pct >= 80 ? "#22c55e" : pct >= 50 ? "#eab308" : "#ef4444";
  const label = pct >= 80 ? "Good" : pct >= 50 ? "Needs work" : "Poor";
  return (
    <div className="flex items-center gap-3" data-testid="seo-score">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth={stroke} />
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
            strokeLinecap="round" strokeDasharray={`${dash} ${c}`} style={{ transition: "stroke-dasharray .5s ease" }} />
        </svg>
        <div className="absolute inset-0 grid place-items-center">
          <span className="text-xl font-bold text-white" data-testid="seo-score-value">{pct}</span>
        </div>
      </div>
      <div>
        <p className="text-xs uppercase tracking-wider text-white/50">SEO Score</p>
        <p className="text-sm font-semibold" style={{ color }}>{label}</p>
        <p className="text-[11px] text-white/40">out of 100</p>
      </div>
    </div>
  );
}
